import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Nav from "../../component/nav/nav";
import "./quill.snow.css";
import css from "./index.module.scss";
import { useTranslation } from "react-i18next";
import Bot from "../../component/bot";
import Beard from "../../component/bread/breadcrumb";
import { getNewsDetail } from "../../api/index";
import { useInView, animated } from "@react-spring/web";
import { toast } from "react-toastify";

const list = [{ name: "$singlee_nw1", path: "/news" }];

function Index() {
  const { t } = useTranslation();
  const location = useLocation();

  const [mobile, setMobile] = useState(window.innerWidth < 1025);
  const [newsContent, setNewsContent] = useState({});

  const {
    state: { id },
  } = useLocation();
  const [newsId, setNewsId] = useState(id ? id : null);

  const navigate = useNavigate();

  const [refFirst, styleFirst] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateX(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateX(0%)",
      },
    }),
    { threshold: 0.1, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );
  const [refSecond, styleSecond] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateY(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0%)",
      },
    }),
    { threshold: 0.1, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );

  const getInfo = async () => {
    const res = await getNewsDetail({ id: newsId, classId: 1 });
    if (res.code === 200) {
      setNewsContent(res.data);
    } else {
      toast.error("获取数据失败", { position: "top-center" });
    }
  };

  const goPrev = () => {
    if (newsContent.lastId) {
      setNewsId(newsContent.lastId);
    } else {
      toast.info("已经是第一篇了", { position: "top-center" });
    }
  };

  const goNext = () => {
    if (newsContent.nextId) {
      setNewsId(newsContent.nextId);
    } else {
      toast.info("已经是最后一篇了", { position: "top-center" });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleResize = () => {
      setMobile(window.innerWidth < 1025);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    getInfo();
  }, [newsId]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{ overflowY: "auto", height: "100%" }}>
      <Nav
        styles={{ position: "fixed", left: "0", top: "0", zIndex: "10" }}
        alwaysNotTransparant={true}
      ></Nav>
      <div className={`${mobile ? css.flexzoneMobile : css.flexzone}`}>
        <div className={css.left}>
          {list.map((item, index) => {
            return (
              <div
                key={index}
                className={`${css.item} ${
                  location.pathname === item.path ? css.activeFont : ""
                }`}
                onClick={() => {
                  navigate(item.path, { replace: true });
                }}
              >
                {t(item.name)}
              </div>
            );
          })}
        </div>
        {mobile ? (
          <></>
        ) : (
          <div className={css.right}>
            <Beard />
          </div>
        )}
      </div>

      <div className={css.contain}>
        <div className={css.top}>
          <div className={css.title}>{newsContent.title}</div>
          <div className={css.subtitle}>
            <div className={css.left}>{"来源：新利软件（集团）"}</div>
            <div>
              {newsContent.updatetime
                ? newsContent.updatetime.split(" ")[0]
                : ""}
            </div>
          </div>
        </div>
        <div className={css.box}>
          <div className={css.first} ref={refFirst}>
            <animated.div style={styleFirst} className={css.inner}>
              <div
                className={`${css.content} ql-editor`}
                dangerouslySetInnerHTML={{ __html: newsContent.content }}
              ></div>
            </animated.div>
          </div>

          <div className={css.second} ref={refSecond}>
            <animated.div style={styleSecond} className={css.inner}>
              <div
                className={css.prev}
                onClick={goPrev}
                style={{ cursor: "pointer" }}
              >
                {t("上一篇") + ":" + t(newsContent.lastTitle)}
              </div>
              <div onClick={goNext} style={{ cursor: "pointer" }}>
                {t("下一篇") + ":" + t(newsContent.nextTitle)}
              </div>
            </animated.div>
          </div>
        </div>
      </div>

      <Bot></Bot>
    </div>
  );
}

export default React.memo(Index);
